<template>
  <div>
    <!-- 日期选择 -->
    <div v-if="titleObj.showDate" class="flex align-items-center">
      <div v-if="dateArr.length < 2" class="text-59">
        {{ $t(dateArr[0].label).d(dateArr[0].text) }}
      </div>
      <yxtf-dropdown
        v-else
        custom-elm
        @visible-change="onDropdownVisible"
        @command="handleDateChange"
      >
       <yxtf-button type="text" class="date-select-btn">
         {{ $t(activeDate.label).d(activeDate.text) }}
         <i :class="iconClass" class="ml4"></i>
       </yxtf-button>
        <yxtf-dropdown-menu slot="dropdown">
          <yxtf-dropdown-item
            v-for="(item, index) of dateArr"
            :key="index"
            :command="item"
            :class="{
              'color-primary-6-i': item.type === titleObj.defaultDateType
            }"
            >{{ $t(item.label).d(item.text) }}</yxtf-dropdown-item
          >
        </yxtf-dropdown-menu>
      </yxtf-dropdown>
       <yxt-tooltip
          v-if="['deptAvg', 'deptSum'].includes(titleObj.objectCode)"
          effect="light"
          placement="top"
          :content="$t(activeDate.tip).d(activeDate.tipText)"
        >
          <yxt-svg
            class="color-gray-6 hover-primary-6 hand ml6"
            width="16px"
            height="16px"
            icon-class="icons/question-cirlce-o"
          />
        </yxt-tooltip>
    </div>
  </div>
</template>
<script>
import { dateList } from '../config';

export default {
  inject: ['titleFun'],
  computed: {
    // 榜单名称数据
    titleObj() {
      return this.titleFun();
    },
    // 日期选择数组
    dateArr() {
      const arr = [];
      this.titleObj.dateArr.forEach(d => {
        arr.push(dateList.find(i => i.type === d));
      });
      arr.sort((a, b) => a.order - b.order);
      return arr;
    },
    // 当前选择的日期
    activeDate() {
      return this.dateArr.find(d => d.type === this.titleObj.defaultDateType) || {};
    }
  },
  data() {
    return {
      iconClass: 'yxtf-icon-arrow-down'
    };
  },
  methods: {
    // 日期类型更改时
    handleDateChange(item) {
      this.$emit('changeDate', item.type);
    },
    // 日期下拉框显示时
    onDropdownVisible(v) {
      this.iconClass = v ? 'yxtf-icon-arrow-up' : 'yxtf-icon-arrow-down';
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
